module.exports = __webpack_public_path__ + "img/153.5ae60ff1.jpg";